

const urls: Record<string, string> = {
    dev: "https://dev-pay-lrk0i9.yoello.com",
    staging: "https://staging-pay-89e5si.yoello.com",
    prod: "https://pay.yoello.com"
}


export function generateConsumerURL() {
    const env = process.env.REACT_APP_ENVIRONMENT;

    if (!env) return urls.prod;
    return urls[env];
}

export function generateReturnURL(path: string) {
    return `${generateConsumerURL()}?returnPath=${path}`;
}

export function generateTemplateURL(path: string) {
    return `${generateConsumerURL()}?returnPath=/o/${path}`;
}

export function generateQRCodeURL(orderId: string) {
    return generateReturnURL(`/o/${orderId}/qr-code`);
}